export default __webpack_public_path__ + "static/media/icon-happy-face-empty.01322cb5.svg";